import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "./App.css";

const ScreenProxy = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    //console.log("id = " + id);
    //console.log(window["ENV"]["SCREEN"][id]);
    //console.log(window.ENV.SCREEN[id]);
    
    useEffect(() => {
        if(!id){
            return;
        }
        if(id == "HORN") {
            navigate(`/carousel/` + process.env.REACT_APP_HORN);
        }
        else if(id == "BAS_1") {
            navigate(`/carousel/` + process.env.REACT_APP_BAS_1);
        }
        else if(id == "BAS_2") {
            navigate(`/carousel/` + process.env.REACT_APP_BAS_2);
        }
        else if(id == "BAS_3") {
            navigate(`/carousel/` + process.env.REACT_APP_BAS_3);
        }
        else if(id == "TEMA_1") {
            navigate(`/carousel/` + process.env.REACT_APP_TEMA_1);
        }
        else if(id == "TEMA_2") {
            navigate(`/carousel/` + process.env.REACT_APP_TEMA_2);
        }
        else if(id == "TEMA_3") {
            navigate(`/carousel/` + process.env.REACT_APP_TEMA_3);
        }
        else if(id == "BAS-1") {
            navigate(`/exhibitions/exhibition/` + process.env.REACT_APP_BAS_1);
        }
        else if(id == "BAS-2") {
            navigate(`/exhibitions/exhibition/` + process.env.REACT_APP_BAS_2);
        }
        else if(id == "BAS-3") {
            navigate(`/exhibitions/exhibition/` + process.env.REACT_APP_BAS_3);
        }
        else if(id == "TEMA-1") {
            navigate(`/exhibitions/exhibition/` + process.env.REACT_APP_TEMA_1);
        }
        else if(id == "TEMA-2") {
            navigate(`/exhibitions/exhibition/` + process.env.REACT_APP_TEMA_2);
        }
        else if(id == "TEMA-3") {
            navigate(`/exhibitions/exhibition/` + process.env.REACT_APP_TEMA_3);
        }
        else {
            navigate(`/exhibitions/exhibition/` + window.ENV.SCREEN[id]);
        }
    
    }, [id]);
    return("");
};

export default ScreenProxy;